<style>
    .spinner {
        margin: 0 auto;
        width: 70px;
        text-align: center;
    }

    .spinner > div {
        width: 9px;
        height: 9px;
        border-radius: 100%;
        display: inline-block;
        -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
        animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    }

    .spinner .bounce1 {
        -webkit-animation-delay: -0.32s;
        animation-delay: -0.32s;
    }

    .spinner .bounce2 {
        -webkit-animation-delay: -0.16s;
        animation-delay: -0.16s;
    }

    @-webkit-keyframes sk-bouncedelay {
        0%, 80%, 100% { -webkit-transform: scale(0) }
        40% { -webkit-transform: scale(1.0) }
    }

    @keyframes sk-bouncedelay {
        0%, 80%, 100% {
            -webkit-transform: scale(0);
            transform: scale(0);
        } 40% {
              -webkit-transform: scale(1.0);
              transform: scale(1.0);
          }
    }
</style>

<template>
    <div class="spinner">
        <div class="bounce1" :style="{backgroundColor: color }"></div>
        <div class="bounce2" :style="{backgroundColor: color }"></div>
        <div class="bounce3" :style="{backgroundColor: color }"></div>
    </div>
</template>

<script>
  export default {
    props: {
        color:{
          type: String,
          default: '#fff'
        }
    },
    data: function () {
      return {

      }
    },
    computed: {

    },
    watch: {},
    methods: {

    },
    mounted() {

    }
  }
</script>
